// Este archivo contiene todas las traducciones para los diferentes idiomas
const translations = {
    // Español
    ES: {
      // Navegación
      'nav.home': 'Inicio',
      'nav.company': 'Compañía',
      'nav.athletes': 'Atletas',
      'nav.service': 'Servicio',
      'nav.contact': 'Contacto',
      
      // Página de inicio
      'home.hero.title': 'Descubre Talento Excepcional En El Fútbol',
      'home.hero.subtitle': 'AFY GROUP representa a futbolistas con habilidades extraordinarias, conectando talento deportivo superior con oportunidades a nivel mundial.',
      'home.hero.cta.viewAthletes': 'Ver Atletas',
      'home.hero.cta.contact': 'Contactar',
      'home.stats.players': 'Futbolistas representados',
    // Español (ES)
        'home.hero.exclusiveRepresentation': 'Representación Exclusiva',
        'home.hero.stats.matches': 'Partidos',
        'home.hero.stats.goals': 'Goles',
        'home.hero.stats.assists': 'Asistencias',

        // Sección de estadísticas
        'home.stats.players': 'Futbolistas representados',
        'home.stats.players.desc': 'Talento de élite de Perú, España, Brasil y otros países',
        'home.stats.success': 'Tasa de éxito',
        'home.stats.success.desc': 'En la colocación de jugadores en equipos profesionales',
        'home.stats.countries': 'Países representados',
        'home.stats.countries.desc': 'Red global de contactos y oportunidades internacionales',
        'home.stats.response': 'Respuesta rápida',
        'home.stats.response.desc': 'Atención personalizada para reclutadores y clubes interesados',
        'home.stats.subtitle': 'Datos de rendimiento',
        'home.stats.title': 'Análisis Profesional para Reclutadores',
        'home.stats.cta': 'Solicitar Información Detallada',

        // Sección de jugadores destacados
        'home.featured.subtitle': 'Portfolio Exclusivo',
        'home.featured.title': 'Nuestros Jugadores Destacados',
        'home.featured.desc': 'Profesionales con trayectoria internacional y jóvenes promesas con potencial extraordinario.',
        'home.featured.viewProfile': 'Ver perfil',
        'home.featured.player': 'Jugador',
        'home.featured.professional': 'Profesional',
        'home.featured.prevPlayer': 'Jugador anterior',
        'home.featured.nextPlayer': 'Siguiente jugador',
        'home.featured.page': 'Página',
        'home.featured.viewAll': 'Ver Todos los Atletas',

        // Sección de servicios
        'home.services.representation.title': 'Representación de Élite',
        'home.services.representation.desc': 'Gestión integral y personalizada para cada uno de nuestros atletas seleccionados.',
        'home.services.scouting.title': 'Scouting Profesional',
        'home.services.scouting.desc': 'Análisis detallado de rendimiento y métricas avanzadas de nuestros jugadores.',
        'home.services.contracts.title': 'Intermediación de Contratos',
        'home.services.contracts.desc': 'Facilitamos negociaciones transparentes y beneficiosas para todas las partes.',
        'home.services.legal.title': 'Soporte Legal Especializado',
        'home.services.legal.desc': 'Asesoramiento experto en normativas de transferencias internacionales y contratos.',
        'home.services.subtitle': 'Nuestros servicios',
        'home.services.title': 'Soluciones Integrales para Clubes y Reclutadores',
        'home.services.desc': 'Ofrecemos una gama completa de servicios para facilitar la identificación y contratación de talentos excepcionales.',
        'home.services.cta': 'Explorar Todos los Servicios',

        // Sección Sobre nosotros
        'home.about.subtitle': 'Nuestra Misión',
        'home.about.title': 'Desarrollamos el Potencial Máximo de Cada Talento',
        'home.about.desc1': 'Somos una empresa nikkei enfocada en gestionar y dirigir de manera integral el desarrollo y crecimiento profesional de nuestros jóvenes futbolistas previamente seleccionados más allá del deporte.',
        'home.about.desc2': 'Nuestro compromiso es representar solo a jugadores con potencial real, ofreciendo a los clubes y reclutadores talentos verificados y preparados para el alto rendimiento.',
        'home.about.feature1.title': 'Selección Rigurosa',
        'home.about.feature1.desc': 'Solo representamos a jugadores con habilidades comprobadas',
        'home.about.feature2.title': 'Desarrollo Profesional',
        'home.about.feature2.desc': 'Preparación técnica, táctica y mental personalizada',
        'home.about.feature3.title': 'Gestión Internacional',
        'home.about.feature3.desc': 'Contactos con clubes en múltiples ligas y países',
        'home.about.feature4.title': 'Transparencia Total',
        'home.about.feature4.desc': 'Claridad en contratos y negociaciones con todas las partes',
        'home.about.cta': 'Más Sobre Nosotros',

        // CTA final
        'home.cta.title': '¿Buscando talentos para tu equipo?',
        'home.cta.desc': 'Contacta con nosotros para conocer más detalles sobre nuestros atletas y discutir posibles colaboraciones para tu club.',
        'home.cta.contact': 'Contactar Ahora',
        'home.cta.viewAthletes': 'Ver Atletas',
      
      // Página de atletas
      'athletes.title': 'ATLETAS',
      'athletes.subtitle': 'Descubre nuestro talentoso equipo de futbolistas profesionales representados por APY GROUP',
      'athletes.cta': 'DESCUBRIR ATLETAS',
      'athletes.featured': 'ATLETA DESTACADO',
      'athletes.viewProfile': 'VER PERFIL COMPLETO',
      'athletes.searchPlaceholder': 'Buscar atleta...',
      'athletes.noResults': 'No se encontraron atletas',
      'athletes.tryAgain': 'Intenta con otros filtros o términos de búsqueda',
      'athletes.showAll': 'Mostrar todos los atletas',
      'athletes.contact': 'CONTACTAR',

      // Perfil Athlete
    'athlete.loading': 'Cargando perfil...',
    'athlete.notFound.title': 'Atleta no encontrado',
    'athlete.notFound.message': 'No pudimos encontrar el perfil de este atleta. Es posible que haya sido trasladado o eliminado.',
    'athlete.notFound.button': 'Volver a la lista de atletas',

    'athlete.tabs.info': 'Información',
    'athlete.tabs.stats': 'Estadísticas',
    'athlete.tabs.career': 'Carrera',
    'athlete.tabs.highlights': 'Highlights',
    'athlete.tabs.media': 'Media',

    'athlete.breadcrumbs.home': 'Inicio',
    'athlete.breadcrumbs.athletes': 'Atletas',

    'athlete.info.personal': 'Información personal',
    'athlete.info.fullName': 'Nombre completo',
    'athlete.info.age': 'Edad',
    'athlete.info.birthDate': 'Fecha de nacimiento',
    'athlete.info.birthPlace': 'Lugar de nacimiento',
    'athlete.info.height': 'Altura',
    'athlete.info.position': 'Posición',
    'athlete.info.foot': 'Pie dominante',
    'athlete.info.number': 'Dorsal',
    'athlete.info.nationality': 'Nacionalidad',
    'athlete.info.noData': 'No disponible',

    'athlete.info.fieldPosition': 'Posición en el campo',
    'athlete.info.contractDetails': 'Detalles de contrato',
    'athlete.info.signed': 'Firmado',
    'athlete.info.validUntil': 'Válido hasta',
    'athlete.info.lastRenewal': 'Última renovación',

    'athlete.info.marketValue': 'Valor de mercado',
    'athlete.info.maxValue': 'Valor máximo',
    'athlete.info.valueHistory': 'Ver historial de valores',
    'athlete.info.competitions': 'Competiciones',

    'athlete.info.currentTeam': 'Equipo actual',
    'athlete.info.since': 'Desde',
    'athlete.info.representedBy': 'Representado por',
    'athlete.info.sportsRepresentation': 'Representación deportiva',
    'athlete.info.agent': 'Agente',

    'athlete.stats.matches': 'Partidos jugados',
    'athlete.stats.goals': 'Goles anotados',
    'athlete.stats.assists': 'Asistencias',
    'athlete.stats.minutes': 'Minutos jugados',
    'athlete.stats.yellowCards': 'Tarjetas amarillas',
    'athlete.stats.redCards': 'Tarjetas rojas',
    'athlete.stats.passAccuracy': '% Precisión de pases',
    'athlete.stats.cleanSheets': 'Porterías a cero',
    'athlete.stats.savePercentage': '% Paradas',

    'athlete.career.title': 'Trayectoria',
    'athlete.career.season': 'Temporada',
    'athlete.career.value': 'Valor',
    'athlete.career.noData': 'No hay datos de trayectoria disponibles para este jugador.',
    'athlete.career.achievements': 'Logros destacados',

    'athlete.highlights.title': 'Highlights de',
    'athlete.highlights.bestMoments': 'Mejores momentos',
    'athlete.highlights.defaultDesc': 'Disfruta de los mejores momentos de',
    'athlete.highlights.with': 'con',
    'athlete.highlights.skillsText': 'Habilidad, talento y pasión por el fútbol.',
    'athlete.highlights.moreVideos': 'Más videos',
    'athlete.highlights.video': 'Video',
    'athlete.highlights.noVideos.title': 'No hay videos disponibles',
    'athlete.highlights.noVideos.message': 'Actualmente no hay videos de highlights disponibles para este jugador.',
    'athlete.highlights.keyStats': 'Estadísticas destacadas',
    'athlete.highlights.matches': 'Partidos',
    'athlete.highlights.goals': 'Goles',
    'athlete.highlights.assists': 'Asistencias',
    'athlete.highlights.hoursPlayed': 'Horas jugadas',

    'athlete.media.title': 'Imágenes del jugador',
    'athlete.media.moreContent.title': '¿Necesitas más contenido multimedia?',
    'athlete.media.moreContent.message': 'Contacta con nosotros para solicitar más fotografías y videos de',
    'athlete.media.moreContent.button': 'Contactar',

    'athlete.cta.interested': '¿Interesado en este atleta?',
    'athlete.cta.contact': 'Contacta con APY GROUP para más información sobre',
    'athlete.cta.contactButton': 'Contactar',
    'athlete.cta.otherButton': 'Ver otros atletas',
      
      // Página de compañía
      'company.title': 'COMPAÑÍA',
      'company.subtitle': 'Transformando carreras deportivas con un enfoque integral, profesional y humano.',
      'company.cta.know': 'CONÓCENOS',
      'company.cta.values': 'NUESTROS VALORES',
      'company.who.title': 'QUIÉNES SOMOS',
      'company.who.desc1': 'Somos una empresa nikkei enfocada en gestionar y dirigir de manera integral el desarrollo y crecimiento profesional de nuestros jóvenes futbolistas previamente seleccionados más allá del deporte.',
      'company.who.desc2': 'Nuestro enfoque combina tradición, disciplina y excelencia para crear trayectorias deportivas sólidas y sostenibles que beneficien tanto al atleta como a los clubes con los que trabajamos.',
      'company.feature.international': 'Experiencia internacional',
      'company.feature.holistic': 'Enfoque holístico',
      'company.feature.network': 'Red global de contactos',
      'company.objective.title': 'NUESTRO OBJETIVO',
      'company.objective.desc': 'Cuidar a nuestros futbolistas y su entorno con el objetivo de ayudarlos en una mejora continua tanto en el ámbito profesional como en el personal. Comprometiéndonos en marcar una verdadera diferencia a la hora de representar a nuestros jugadores y ofrecer el mejor servicio a los Clubes.',
      'company.stats.players': 'Futbolistas representados',
      'company.stats.countries': 'Países con presencia',
      'company.stats.satisfaction': 'Tasa de satisfacción',
      'company.values.title': 'NUESTROS VALORES',
      'company.values.transparency.title': 'TRANSPARENCIA',
      'company.values.transparency.desc': 'Comunicación clara y honesta con nuestros atletas y clubes',
      'company.values.trust.title': 'CONFIANZA',
      'company.values.trust.desc': 'Construimos relaciones duraderas basadas en la confianza mutua',
      'company.values.closeness.title': 'CERCANÍA',
      'company.values.closeness.desc': 'Trato personalizado y apoyo constante a cada atleta',
      'company.values.professionalism.title': 'PROFESIONALISMO',
      'company.values.professionalism.desc': 'Servicio de alta calidad con estándares internacionales',
      'company.philosophy.title': 'Nuestra Filosofía',
      'company.philosophy.desc': 'La excelencia no es un acto, sino un hábito. Cada día nos esforzamos por superar nuestros propios estándares.',
      'company.philosophy.cta': 'CONTACTO',
      'company.team.title': 'NUESTRO EQUIPO',
      'company.team.join': 'ÚNETE A NUESTRO EQUIPO',
      
      // Página de servicio
      'services.title': 'NUESTROS SERVICIOS',
      'services.subtitle': 'Ofrecemos soluciones integrales para futbolistas que aspiran a una carrera internacional de éxito',
      'services.cta.discover': 'DESCUBRE MÁS',
      'services.cta.contact': 'CONTACTAR',
      'services.section.title': 'SERVICIOS PROFESIONALES',
      'services.section.desc': 'Cada servicio está diseñado para potenciar la carrera de nuestros atletas, con un enfoque personalizado que maximiza sus oportunidades.',
      'services.details': 'Ver detalles',
      'services.premiumService': 'Servicio Premium',
      'services.mainFeatures': 'Características principales',
      'services.requestInfo': 'Solicitar información',
      'services.process.title': 'CÓMO TRABAJAMOS',
      'services.process.desc': 'Nuestro enfoque metódico garantiza resultados óptimos para cada atleta, asegurando un desarrollo integral a largo plazo.',
      'services.commitment.title': 'Compromiso con la excelencia',
      'services.commitment.desc': 'Nuestro enfoque personalizado y nuestra dedicación a la excelencia garantizan que cada atleta reciba atención individualizada y oportunidades adaptadas a su perfil y objetivos. Trabajamos con un número limitado de talentos para asegurar la máxima calidad en nuestros servicios.',
      'services.partnerships.title': 'ALIANZAS ESTRATÉGICAS',
      'services.partnerships.desc': 'Nuestras alianzas internacionales permiten a nuestros atletas acceder a oportunidades exclusivas en mercados clave, con especial enfoque en Japón y Asia.',
      'services.partnerships.moreInfo': 'Más información',
      'services.global.title': 'Red Global de Oportunidades',
      'services.global.desc': 'Contamos con una extensa red de contactos en clubes de Japón, Europa y América, ofreciendo oportunidades exclusivas para nuestros representados.',
      'services.global.cta': 'EXPLORAR OPORTUNIDADES',
      'services.testimonials.title': 'LO QUE DICEN NUESTROS ATLETAS',
      'services.testimonials.cta': 'CONSULTA PERSONALIZADA',
      
      // Página de contacto
      'contact.title': 'CONTACTO',
      'contact.form.name': 'NOMBRE',
      'contact.form.lastname': 'APELLIDO',
      'contact.form.email': 'E-MAIL',
      'contact.form.phone': 'TELÉFONO',
      'contact.form.company': 'EMPRESA',
      'contact.form.inquiry': 'CONSULTA',
      'contact.form.send': 'ENVIAR',
      'contact.form.success.title': 'Mensaje Enviado',
      'contact.form.success.desc': 'Gracias por contactarnos. Nuestro equipo responderá a tu consulta lo antes posible.',
      'contact.form.success.cta': 'Enviar otro mensaje',
      
      // Footer
      'footer.company.desc': 'Empresa nikkei dedicada a la representación y gestión integral de futbolistas.',
      'footer.quickLinks': 'Enlaces Rápidos',
      'footer.contact': 'Contacto',
      'footer.copyright': 'Todos los derechos reservados.',
      
      // Servicios específicos
      'service.representation.title': 'Representación',
      'service.representation.short': 'Gestión integral de la carrera deportiva',
      'service.representation.desc': 'Representamos a nuestros atletas con los más altos estándares éticos, garantizando acuerdos transparentes y ventajosos con clubes nacionales e internacionales. Gestionamos todos los aspectos contractuales para que el jugador pueda concentrarse en su rendimiento.',
      
      'service.intermediation.title': 'Intermediación',
      'service.intermediation.short': 'Conexiones estratégicas con clubes globales',
      'service.intermediation.desc': 'Facilitamos conexiones entre clubes y jugadores, negociando transferencias y préstamos con un enfoque en beneficiar a todas las partes. Nuestra red internacional nos permite identificar las mejores oportunidades para nuestros atletas.',
      
      'service.publicity.title': 'Publicidad',
      'service.publicity.short': 'Gestión de imagen y patrocinios',
      'service.publicity.desc': 'Gestionamos la imagen pública y presencia en redes sociales de nuestros atletas, obteniendo patrocinios y alianzas comerciales que potencian su marca personal mientras maximizan sus ingresos fuera del campo.',
      
      'service.coaching.title': 'Coaching',
      'service.coaching.short': 'Desarrollo personal y mental',
      'service.coaching.desc': 'Brindamos orientación personalizada para el desarrollo personal y profesional, ayudando a nuestros atletas a establecer y alcanzar objetivos, superar obstáculos y optimizar su rendimiento tanto dentro como fuera del campo.',
      
      'service.legal.title': 'Asesoría Legal',
      'service.legal.short': 'Protección jurídica especializada',
      'service.legal.desc': 'Contamos con un equipo de expertos legales especializados en derecho deportivo que aseguran la protección de los intereses de nuestros atletas en todas sus negociaciones, contratos y asuntos legales relacionados con su carrera.',
      
      'service.international.title': 'Nexo Internacional',
      'service.international.short': 'Oportunidades globales para futbolistas',
      'service.international.desc': 'Especializados en crear puentes entre futbolistas latinoamericanos y ligas asiáticas, europeas y norteamericanas. Facilitamos pruebas, transferencias y adaptación cultural para maximizar el éxito en el extranjero.',
    },
    
    // English
    EN: {
      // Navigation
      'nav.home': 'Home',
      'nav.company': 'Company',
      'nav.athletes': 'Athletes',
      'nav.service': 'Services',
      'nav.contact': 'Contact',
      
      // Home page
      'home.hero.title': 'Discover Exceptional Football Talent',
      'home.hero.subtitle': 'AFY GROUP represents footballers with extraordinary skills, connecting superior athletic talent with worldwide opportunities.',
      'home.hero.cta.viewAthletes': 'View Athletes',
      'home.hero.cta.contact': 'Contact Us',
       'home.hero.exclusiveRepresentation': 'Exclusive Representation',
        'home.hero.stats.matches': 'Matches',
        'home.hero.stats.goals': 'Goals',
        'home.hero.stats.assists': 'Assists',

        // Stats section
        'home.stats.players': 'Represented players',
        'home.stats.players.desc': 'Elite talent from Peru, Spain, Brazil and other countries',
        'home.stats.success': 'Success rate',
        'home.stats.success.desc': 'In placing players in professional teams',
        'home.stats.countries': 'Represented countries',
        'home.stats.countries.desc': 'Global network of contacts and international opportunities',
        'home.stats.response': 'Fast response',
        'home.stats.response.desc': 'Personalized attention for recruiters and interested clubs',
        'home.stats.subtitle': 'Performance data',
        'home.stats.title': 'Professional Analysis for Recruiters',
        'home.stats.cta': 'Request Detailed Information',

        // Featured players section
        'home.featured.subtitle': 'Exclusive Portfolio',
        'home.featured.title': 'Our Featured Players',
        'home.featured.desc': 'Professionals with international experience and young promises with extraordinary potential.',
        'home.featured.viewProfile': 'View profile',
        'home.featured.player': 'Player',
        'home.featured.professional': 'Professional',
        'home.featured.prevPlayer': 'Previous player',
        'home.featured.nextPlayer': 'Next player',
        'home.featured.page': 'Page',
        'home.featured.viewAll': 'View All Athletes',

        // Services section
        'home.services.representation.title': 'Elite Representation',
        'home.services.representation.desc': 'Comprehensive and personalized management for each of our selected athletes.',
        'home.services.scouting.title': 'Professional Scouting',
        'home.services.scouting.desc': 'Detailed performance analysis and advanced metrics of our players.',
        'home.services.contracts.title': 'Contract Intermediation',
        'home.services.contracts.desc': 'We facilitate transparent and beneficial negotiations for all parties.',
        'home.services.legal.title': 'Specialized Legal Support',
        'home.services.legal.desc': 'Expert advice on international transfer regulations and contracts.',
        'home.services.subtitle': 'Our services',
        'home.services.title': 'Comprehensive Solutions for Clubs and Recruiters',
        'home.services.desc': 'We offer a complete range of services to facilitate the identification and recruitment of exceptional talent.',
        'home.services.cta': 'Explore All Services',

        // About us section
        'home.about.subtitle': 'Our Mission',
        'home.about.title': 'We Develop the Maximum Potential of Each Talent',
        'home.about.desc1': 'We are a Nikkei company focused on comprehensively managing and directing the professional development and growth of our previously selected young footballers beyond the sport.',
        'home.about.desc2': 'Our commitment is to represent only players with real potential, offering clubs and recruiters verified talents ready for high performance.',
        'home.about.feature1.title': 'Rigorous Selection',
        'home.about.feature1.desc': 'We only represent players with proven skills',
        'home.about.feature2.title': 'Professional Development',
        'home.about.feature2.desc': 'Personalized technical, tactical and mental preparation',
        'home.about.feature3.title': 'International Management',
        'home.about.feature3.desc': 'Contacts with clubs in multiple leagues and countries',
        'home.about.feature4.title': 'Total Transparency',
        'home.about.feature4.desc': 'Clarity in contracts and negotiations with all parties',
        'home.about.cta': 'More About Us',

        // Final CTA
        'home.cta.title': 'Looking for talent for your team?',
        'home.cta.desc': 'Contact us to learn more about our athletes and discuss possible collaborations for your club.',
        'home.cta.contact': 'Contact Now',
        'home.cta.viewAthletes': 'View Athletes',

      
      // Athletes page
      'athletes.title': 'ATHLETES',
      'athletes.subtitle': 'Discover our talented team of professional footballers represented by APY GROUP',
      'athletes.cta': 'DISCOVER ATHLETES',
      'athletes.featured': 'FEATURED ATHLETE',
      'athletes.viewProfile': 'VIEW COMPLETE PROFILE',
      'athletes.searchPlaceholder': 'Search athlete...',
      'athletes.noResults': 'No athletes found',
      'athletes.tryAgain': 'Try with other filters or search terms',
      'athletes.showAll': 'Show all athletes',
      'athletes.contact': 'CONTACT',

        // Athlete profile page
        'athlete.loading': 'Loading profile...',
        'athlete.notFound.title': 'Athlete Not Found',
        'athlete.notFound.message': 'We couldn\'t find this athlete\'s profile. It may have been moved or deleted.',
        'athlete.notFound.button': 'Return to athletes list',

        'athlete.tabs.info': 'Information',
        'athlete.tabs.stats': 'Statistics',
        'athlete.tabs.career': 'Career',
        'athlete.tabs.highlights': 'Highlights',
        'athlete.tabs.media': 'Media',

        'athlete.breadcrumbs.home': 'Home',
        'athlete.breadcrumbs.athletes': 'Athletes',

        'athlete.info.personal': 'Personal Information',
        'athlete.info.fullName': 'Full Name',
        'athlete.info.age': 'Age',
        'athlete.info.birthDate': 'Date of Birth',
        'athlete.info.birthPlace': 'Place of Birth',
        'athlete.info.height': 'Height',
        'athlete.info.position': 'Position',
        'athlete.info.foot': 'Preferred Foot',
        'athlete.info.number': 'Jersey Number',
        'athlete.info.nationality': 'Nationality',
        'athlete.info.noData': 'Not available',

        'athlete.info.fieldPosition': 'Field Position',
        'athlete.info.contractDetails': 'Contract Details',
        'athlete.info.signed': 'Signed',
        'athlete.info.validUntil': 'Valid Until',
        'athlete.info.lastRenewal': 'Last Renewal',

        'athlete.info.marketValue': 'Market Value',
        'athlete.info.maxValue': 'Maximum Value',
        'athlete.info.valueHistory': 'View value history',
        'athlete.info.competitions': 'Competitions',

        'athlete.info.currentTeam': 'Current Team',
        'athlete.info.since': 'Since',
        'athlete.info.representedBy': 'Represented by',
        'athlete.info.sportsRepresentation': 'Sports representation',
        'athlete.info.agent': 'Agent',

        'athlete.stats.matches': 'Matches played',
        'athlete.stats.goals': 'Goals scored',
        'athlete.stats.assists': 'Assists',
        'athlete.stats.minutes': 'Minutes played',
        'athlete.stats.yellowCards': 'Yellow cards',
        'athlete.stats.redCards': 'Red cards',
        'athlete.stats.passAccuracy': 'Pass accuracy %',
        'athlete.stats.cleanSheets': 'Clean sheets',
        'athlete.stats.savePercentage': 'Save percentage %',

        'athlete.career.title': 'Career',
        'athlete.career.season': 'Season',
        'athlete.career.value': 'Value',
        'athlete.career.noData': 'No career data available for this player.',
        'athlete.career.achievements': 'Key Achievements',

        'athlete.highlights.title': 'Highlights of',
        'athlete.highlights.bestMoments': 'Best moments',
        'athlete.highlights.defaultDesc': 'Enjoy the best moments of',
        'athlete.highlights.with': 'with',
        'athlete.highlights.skillsText': 'Skill, talent, and passion for football.',
        'athlete.highlights.moreVideos': 'More videos',
        'athlete.highlights.video': 'Video',
        'athlete.highlights.noVideos.title': 'No videos available',
        'athlete.highlights.noVideos.message': 'There are currently no highlight videos available for this player.',
        'athlete.highlights.keyStats': 'Key Statistics',
        'athlete.highlights.matches': 'Matches',
        'athlete.highlights.goals': 'Goals',
        'athlete.highlights.assists': 'Assists',
        'athlete.highlights.hoursPlayed': 'Hours played',

        'athlete.media.title': 'Player Images',
        'athlete.media.moreContent.title': 'Need more media content?',
        'athlete.media.moreContent.message': 'Contact us to request more photos and videos of',
        'athlete.media.moreContent.button': 'Contact',

        'athlete.cta.interested': 'Interested in this athlete?',
        'athlete.cta.contact': 'Contact APY GROUP for more information about',
        'athlete.cta.contactButton': 'Contact',
        'athlete.cta.otherButton': 'View other athletes',
      
      // Company page
      'company.title': 'COMPANY',
      'company.subtitle': 'Transforming sports careers with a comprehensive, professional, and human approach.',
      'company.cta.know': 'ABOUT US',
      'company.cta.values': 'OUR VALUES',
      'company.who.title': 'WHO WE ARE',
      'company.who.desc1': 'We are a Nikkei company focused on comprehensively managing and directing the professional development and growth of our previously selected young footballers beyond the sport.',
      'company.who.desc2': 'Our approach combines tradition, discipline, and excellence to create solid and sustainable sports trajectories that benefit both the athlete and the clubs we work with.',
      'company.feature.international': 'International experience',
      'company.feature.holistic': 'Holistic approach',
      'company.feature.network': 'Global contact network',
      'company.objective.title': 'OUR OBJECTIVE',
      'company.objective.desc': 'To care for our footballers and their environment with the aim of helping them in continuous improvement both professionally and personally. Committing to make a real difference when representing our players and offering the best service to the Clubs.',
      'company.stats.players': 'Represented players',
      'company.stats.countries': 'Countries with presence',
      'company.stats.satisfaction': 'Satisfaction rate',
      'company.values.title': 'OUR VALUES',
      'company.values.transparency.title': 'TRANSPARENCY',
      'company.values.transparency.desc': 'Clear and honest communication with our athletes and clubs',
      'company.values.trust.title': 'TRUST',
      'company.values.trust.desc': 'We build lasting relationships based on mutual trust',
      'company.values.closeness.title': 'CLOSENESS',
      'company.values.closeness.desc': 'Personalized treatment and constant support for each athlete',
      'company.values.professionalism.title': 'PROFESSIONALISM',
      'company.values.professionalism.desc': 'High-quality service with international standards',
      'company.philosophy.title': 'Our Philosophy',
      'company.philosophy.desc': 'Excellence is not an act, but a habit. Every day we strive to exceed our own standards.',
      'company.philosophy.cta': 'CONTACT',
      'company.team.title': 'OUR TEAM',
      'company.team.join': 'JOIN OUR TEAM',
      
      // Services page
      'services.title': 'OUR SERVICES',
      'services.subtitle': 'We offer comprehensive solutions for footballers who aspire to a successful international career',
      'services.cta.discover': 'DISCOVER MORE',
      'services.cta.contact': 'CONTACT',
      'services.section.title': 'PROFESSIONAL SERVICES',
      'services.section.desc': 'Each service is designed to enhance the career of our athletes, with a personalized approach that maximizes their opportunities.',
      'services.details': 'View details',
      'services.premiumService': 'Premium Service',
      'services.mainFeatures': 'Main features',
      'services.requestInfo': 'Request information',
      'services.process.title': 'HOW WE WORK',
      'services.process.desc': 'Our methodical approach guarantees optimal results for each athlete, ensuring long-term comprehensive development.',
      'services.commitment.title': 'Commitment to excellence',
      'services.commitment.desc': 'Our personalized approach and dedication to excellence ensure that each athlete receives individualized attention and opportunities tailored to their profile and objectives. We work with a limited number of talents to ensure the highest quality in our services.',
      'services.partnerships.title': 'STRATEGIC ALLIANCES',
      'services.partnerships.desc': 'Our international alliances allow our athletes to access exclusive opportunities in key markets, with a special focus on Japan and Asia.',
      'services.partnerships.moreInfo': 'More information',
      'services.global.title': 'Global Network of Opportunities',
      'services.global.desc': 'We have an extensive network of contacts in clubs in Japan, Europe, and America, offering exclusive opportunities for our represented players.',
      'services.global.cta': 'EXPLORE OPPORTUNITIES',
      'services.testimonials.title': 'WHAT OUR ATHLETES SAY',
      'services.testimonials.cta': 'PERSONALIZED CONSULTATION',
      
      // Contact page
      'contact.title': 'CONTACT',
      'contact.form.name': 'NAME',
      'contact.form.lastname': 'SURNAME',
      'contact.form.email': 'E-MAIL',
      'contact.form.phone': 'PHONE',
      'contact.form.company': 'COMPANY',
      'contact.form.inquiry': 'INQUIRY',
      'contact.form.send': 'SEND',
      'contact.form.success.title': 'Message Sent',
      'contact.form.success.desc': 'Thank you for contacting us. Our team will respond to your inquiry as soon as possible.',
      'contact.form.success.cta': 'Send another message',
      
      // Footer
      'footer.company.desc': 'Nikkei company dedicated to the representation and comprehensive management of footballers.',
      'footer.quickLinks': 'Quick Links',
      'footer.contact': 'Contact',
      'footer.copyright': 'All rights reserved.',
      
      // Specific services
      'service.representation.title': 'Representation',
      'service.representation.short': 'Comprehensive career management',
      'service.representation.desc': 'We represent our athletes with the highest ethical standards, ensuring transparent and advantageous agreements with national and international clubs. We manage all contractual aspects so that the player can focus on their performance.',
      
      'service.intermediation.title': 'Intermediation',
      'service.intermediation.short': 'Strategic connections with global clubs',
      'service.intermediation.desc': 'We facilitate connections between clubs and players, negotiating transfers and loans with a focus on benefiting all parties. Our international network allows us to identify the best opportunities for our athletes.',
      
      'service.publicity.title': 'Publicity',
      'service.publicity.short': 'Image and sponsorship management',
      'service.publicity.desc': 'We manage the public image and social media presence of our athletes, obtaining sponsorships and commercial alliances that enhance their personal brand while maximizing their income off the field.',
      
      'service.coaching.title': 'Coaching',
      'service.coaching.short': 'Personal and mental development',
      'service.coaching.desc': 'We provide personalized guidance for personal and professional development, helping our athletes establish and achieve goals, overcome obstacles, and optimize their performance both on and off the field.',
      
      'service.legal.title': 'Legal Advisory',
      'service.legal.short': 'Specialized legal protection',
      'service.legal.desc': 'We have a team of legal experts specialized in sports law who ensure the protection of our athletes interests in all their negotiations, contracts, and legal matters related to their career.',
      
      'service.international.title': 'International Nexus',
      'service.international.short': 'Global opportunities for footballers',
      'service.international.desc': 'Specialized in creating bridges between Latin American footballers and Asian, European, and North American leagues. We facilitate trials, transfers, and cultural adaptation to maximize success abroad.',
    },
    
    // Japanese
    JPN: {
      // Navigation
      'nav.home': 'ホーム',
      'nav.company': '会社概要',
      'nav.athletes': '選手',
      'nav.service': 'サービス',
      'nav.contact': 'お問い合わせ',
      
      // Home page
      'home.hero.title': '卓越したサッカー才能を発見する',
      'home.hero.subtitle': 'AFY GROUPは、優れたスキルを持つサッカー選手を代表し、優れた選手を世界中の機会と結びつけます。',
      'home.hero.cta.viewAthletes': '選手を見る',
      'home.hero.cta.contact': '連絡する',
        'home.hero.exclusiveRepresentation': '独占代理',
        'home.hero.stats.matches': '試合',
        'home.hero.stats.goals': 'ゴール',
        'home.hero.stats.assists': 'アシスト',

        // 統計セクション
        'home.stats.players': '所属選手',
        'home.stats.players.desc': 'ペルー、スペイン、ブラジルなど各国のエリート選手',
        'home.stats.success': '成功率',
        'home.stats.success.desc': 'プロチームへの選手配置において',
        'home.stats.countries': '対象国',
        'home.stats.countries.desc': '世界的なネットワークと国際的な機会',
        'home.stats.response': '迅速な対応',
        'home.stats.response.desc': 'スカウトやクラブへのパーソナライズされたサービス',
        'home.stats.subtitle': 'パフォーマンスデータ',
        'home.stats.title': 'スカウト向けプロフェッショナル分析',
        'home.stats.cta': '詳細情報のリクエスト',

        // 注目選手セクション
        'home.featured.subtitle': '特選ポートフォリオ',
        'home.featured.title': '注目選手',
        'home.featured.desc': '国際経験を持つプロと非凡な才能を持つ若き有望株。',
        'home.featured.viewProfile': 'プロフィール',
        'home.featured.player': '選手',
        'home.featured.professional': 'プロフェッショナル',
        'home.featured.prevPlayer': '前の選手',
        'home.featured.nextPlayer': '次の選手',
        'home.featured.page': 'ページ',
        'home.featured.viewAll': '全ての選手を見る',

        // サービスセクション
        'home.services.representation.title': 'エリート代理',
        'home.services.representation.desc': '選ばれた選手一人ひとりの包括的かつパーソナライズされた管理。',
        'home.services.scouting.title': 'プロフェッショナルスカウティング',
        'home.services.scouting.desc': '選手のパフォーマンス詳細分析と高度な指標。',
        'home.services.contracts.title': '契約仲介',
        'home.services.contracts.desc': 'すべての関係者に透明で有益な交渉を促進します。',
        'home.services.legal.title': '専門的な法的支援',
        'home.services.legal.desc': '国際移籍規制と契約に関する専門的なアドバイス。',
        'home.services.subtitle': '私たちのサービス',
        'home.services.title': 'クラブとスカウトのための総合的なソリューション',
        'home.services.desc': '優れた才能の発掘と採用を容易にするための完全なサービス範囲を提供します。',
        'home.services.cta': 'すべてのサービスを見る',

        // 私たちについてセクション
        'home.about.subtitle': '私たちのミッション',
        'home.about.title': '各選手の可能性を最大限に引き出す',
        'home.about.desc1': '私たちは、スポーツを超えて事前に選ばれた若いサッカー選手のプロフェッショナルな発展と成長を包括的に管理・指導することに焦点を当てる日系企業です。',
        'home.about.desc2': '私たちの使命は、真の可能性を持つ選手のみを代表し、クラブやスカウトに高いパフォーマンスの準備ができた検証済みの才能を提供することです。',
        'home.about.feature1.title': '厳格な選考',
        'home.about.feature1.desc': '実証されたスキルを持つ選手のみを代表',
        'home.about.feature2.title': 'プロフェッショナルな育成',
        'home.about.feature2.desc': 'パーソナライズされた技術的、戦術的、精神的準備',
        'home.about.feature3.title': '国際的な管理',
        'home.about.feature3.desc': '複数のリーグや国のクラブとのコンタクト',
        'home.about.feature4.title': '完全な透明性',
        'home.about.feature4.desc': 'すべての関係者との契約と交渉における明確さ',
        'home.about.cta': '私たちについての詳細',

        // 最終CTA
        'home.cta.title': 'チームの才能を探していますか？',
        'home.cta.desc': '私たちの選手についての詳細を知り、あなたのクラブのための可能な協力について議論するために、お問い合わせください。',
        'home.cta.contact': '今すぐ連絡する',
        'home.cta.viewAthletes': '選手を見る',
      
      // Athletes page
      'athletes.title': '選手',
      'athletes.subtitle': 'APY GROUPが代表するプロサッカー選手の才能あるチームを発見してください',
      'athletes.cta': '選手を発見',
      'athletes.featured': '注目の選手',
      'athletes.viewProfile': '完全なプロフィールを表示',
      'athletes.searchPlaceholder': '選手を検索...',
      'athletes.noResults': '選手が見つかりません',
      'athletes.tryAgain': '他のフィルターまたは検索語を試してください',
      'athletes.showAll': 'すべての選手を表示',
      'athletes.contact': 'お問い合わせ',

      // 選手プロフィールページ
        'athlete.loading': 'プロフィール読み込み中...',
        'athlete.notFound.title': '選手が見つかりません',
        'athlete.notFound.message': 'この選手のプロフィールが見つかりませんでした。移動または削除された可能性があります。',
        'athlete.notFound.button': '選手リストに戻る',

        'athlete.tabs.info': '情報',
        'athlete.tabs.stats': '統計',
        'athlete.tabs.career': '経歴',
        'athlete.tabs.highlights': 'ハイライト',
        'athlete.tabs.media': 'メディア',

        'athlete.breadcrumbs.home': 'ホーム',
        'athlete.breadcrumbs.athletes': '選手',

        'athlete.info.personal': '個人情報',
        'athlete.info.fullName': 'フルネーム',
        'athlete.info.age': '年齢',
        'athlete.info.birthDate': '生年月日',
        'athlete.info.birthPlace': '出生地',
        'athlete.info.height': '身長',
        'athlete.info.position': 'ポジション',
        'athlete.info.foot': '利き足',
        'athlete.info.number': '背番号',
        'athlete.info.nationality': '国籍',
        'athlete.info.noData': '情報なし',

        'athlete.info.fieldPosition': 'フィールドポジション',
        'athlete.info.contractDetails': '契約詳細',
        'athlete.info.signed': '契約日',
        'athlete.info.validUntil': '契約期限',
        'athlete.info.lastRenewal': '最終更新',

        'athlete.info.marketValue': '市場価値',
        'athlete.info.maxValue': '最高価値',
        'athlete.info.valueHistory': '価値履歴を見る',
        'athlete.info.competitions': '大会',

        'athlete.info.currentTeam': '現在のチーム',
        'athlete.info.since': '所属開始',
        'athlete.info.representedBy': '代理人',
        'athlete.info.sportsRepresentation': 'スポーツエージェント',
        'athlete.info.agent': 'エージェント',

        'athlete.stats.matches': '試合数',
        'athlete.stats.goals': 'ゴール数',
        'athlete.stats.assists': 'アシスト数',
        'athlete.stats.minutes': 'プレー時間（分）',
        'athlete.stats.yellowCards': 'イエローカード',
        'athlete.stats.redCards': 'レッドカード',
        'athlete.stats.passAccuracy': 'パス成功率',
        'athlete.stats.cleanSheets': 'クリーンシート',
        'athlete.stats.savePercentage': 'セーブ率',

        'athlete.career.title': '経歴',
        'athlete.career.season': 'シーズン',
        'athlete.career.value': '価値',
        'athlete.career.noData': 'この選手の経歴情報はありません。',
        'athlete.career.achievements': '主な実績',

        'athlete.highlights.title': 'のハイライト',
        'athlete.highlights.bestMoments': 'ベストプレー',
        'athlete.highlights.defaultDesc': 'の最高のプレーをお楽しみください',
        'athlete.highlights.with': 'と共に',
        'athlete.highlights.skillsText': '技術、才能、そしてサッカーへの情熱。',
        'athlete.highlights.moreVideos': '他の動画',
        'athlete.highlights.video': '動画',
        'athlete.highlights.noVideos.title': '動画がありません',
        'athlete.highlights.noVideos.message': '現在、この選手のハイライト動画はありません。',
        'athlete.highlights.keyStats': '主要統計',
        'athlete.highlights.matches': '試合',
        'athlete.highlights.goals': 'ゴール',
        'athlete.highlights.assists': 'アシスト',
        'athlete.highlights.hoursPlayed': 'プレー時間',

        'athlete.media.title': '選手の画像',
        'athlete.media.moreContent.title': 'さらに多くのメディアコンテンツが必要ですか？',
        'athlete.media.moreContent.message': 'の写真や動画をリクエストするにはお問い合わせください',
        'athlete.media.moreContent.button': 'お問い合わせ',

        'athlete.cta.interested': 'この選手に興味がありますか？',
        'athlete.cta.contact': 'についての詳細はAPY GROUPにお問い合わせください',
        'athlete.cta.contactButton': 'お問い合わせ',
        'athlete.cta.otherButton': '他の選手を見る',
      
      // Company page
      'company.title': '会社概要',
      'company.subtitle': '包括的、専門的、人間的なアプローチでスポーツキャリアを変革する。',
      'company.cta.know': '私たちについて',
      'company.cta.values': '私たちの価値観',
      'company.who.title': '私たちは誰か',
      'company.who.desc1': '私たちは、事前に選ばれた若いサッカー選手のスポーツを超えた専門的な発展と成長を包括的に管理・指導する日系企業です。',
      'company.who.desc2': '私たちのアプローチは伝統、規律、卓越性を組み合わせて、選手とともに働くクラブの両方に利益をもたらす堅実で持続可能なスポーツの軌跡を作り出します。',
      'company.feature.international': '国際的な経験',
      'company.feature.holistic': '全体的なアプローチ',
      'company.feature.network': 'グローバルな連絡網',
      'company.objective.title': '私たちの目的',
      'company.objective.desc': '私たちの選手とその環境を大切にし、専門的にも個人的にも継続的な向上を支援することを目的としています。私たちの選手を代表し、クラブに最高のサービスを提供する際に本当の違いを生み出すことに取り組んでいます。',
      'company.stats.players': '代表選手',
      'company.stats.countries': '進出国',
      'company.stats.satisfaction': '満足度',
      'company.values.title': '私たちの価値観',
      'company.values.transparency.title': '透明性',
      'company.values.transparency.desc': '選手やクラブとの明確で誠実なコミュニケーション',
      'company.values.trust.title': '信頼',
      'company.values.trust.desc': '相互信頼に基づく持続的な関係を構築',
      'company.values.closeness.title': '親密さ',
      'company.values.closeness.desc': '各選手へのパーソナライズされた対応と一貫したサポート',
      'company.values.professionalism.title': 'プロフェッショナリズム',
      'company.values.professionalism.desc': '国際的な基準を持つ高品質のサービス',
      'company.philosophy.title': '私たちの哲学',
      'company.philosophy.desc': '卓越性は行為ではなく、習慣です。毎日、私たちは自身の基準を超えるよう努力しています。',
      'company.philosophy.cta': 'お問い合わせ',
      'company.team.title': '私たちのチーム',
      'company.team.join': '私たちのチームに参加',
      
      // Services page
      'services.title': '私たちのサービス',
      'services.subtitle': '成功した国際的なキャリアを目指すサッカー選手のための包括的なソリューションを提供しています',
      'services.cta.discover': 'もっと発見',
      'services.cta.contact': 'お問い合わせ',
      'services.section.title': 'プロフェッショナルサービス',
      'services.section.desc': '各サービスは、選手のキャリアを強化するためにデザインされており、彼らの機会を最大化するパーソナライズされたアプローチを持っています。',
      'services.details': '詳細を見る',
      'services.premiumService': 'プレミアムサービス',
      'services.mainFeatures': '主な特徴',
      'services.requestInfo': '情報をリクエスト',
      'services.process.title': '私たちの仕事方法',
      'services.process.desc': '私たちの体系的なアプローチは、各選手に長期的な包括的発展を確保し、最適な結果を保証します。',
      'services.commitment.title': '卓越性へのコミットメント',
      'services.commitment.desc': '私たちのパーソナライズされたアプローチと卓越性への献身は、各選手が彼らのプロフィールと目標に合わせて個別の注目と機会を受けることを保証します。私たちは、サービスの最高品質を確保するために限られた才能と仕事をしています。',
      'services.partnerships.title': '戦略的提携',
      'services.partnerships.desc': '私たちの国際的な提携により、選手は特に日本とアジアに焦点を当てた主要市場での独占的な機会にアクセスできます。',
      'services.partnerships.moreInfo': '詳細情報',
      'services.global.title': '機会のグローバルネットワーク',
      'services.global.desc': '日本、ヨーロッパ、アメリカのクラブに広範な連絡網を持ち、代表選手に独占的な機会を提供しています。',
      'services.global.cta': '機会を探る',
      'services.testimonials.title': '選手の声',
      'services.testimonials.cta': 'パーソナライズされた相談',
      
      // Contact page
      'contact.title': 'お問い合わせ',
      'contact.form.name': '名前',
      'contact.form.lastname': '苗字',
      'contact.form.email': 'メール',
      'contact.form.phone': '電話',
      'contact.form.company': '会社',
      'contact.form.inquiry': 'お問い合わせ内容',
      'contact.form.send': '送信',
      'contact.form.success.title': 'メッセージが送信されました',
      'contact.form.success.desc': 'お問い合わせありがとうございます。私たちのチームができるだけ早くあなたの問い合わせに返信します。',
      'contact.form.success.cta': '別のメッセージを送信',
      
      // Footer
      'footer.company.desc': 'サッカー選手の代表と包括的な管理に専念する日系企業。',
      'footer.quickLinks': 'クイックリンク',
      'footer.contact': '連絡先',
      'footer.copyright': '全著作権所有。',
      
      // Specific services
      'service.representation.title': '代表',
      'service.representation.short': '包括的なキャリア管理',
      'service.representation.desc': '私たちは最高の倫理基準で選手を代表し、国内外のクラブとの透明で有利な合意を確保します。選手がパフォーマンスに集中できるように、すべての契約面を管理します。',
      
      'service.intermediation.title': '仲介',
      'service.intermediation.short': 'グローバルクラブとの戦略的なつながり',
      'service.intermediation.desc': '私たちはクラブと選手の間のつながりを促進し、すべての当事者に利益をもたらすことに焦点を当てて、移籍やローンを交渉します。私たちの国際的なネットワークにより、選手にとって最高の機会を特定することができます。',
      
      'service.publicity.title': '宣伝',
      'service.publicity.short': 'イメージとスポンサーシップの管理',
      'service.publicity.desc': '選手の公的イメージとソーシャルメディアのプレゼンスを管理し、彼らの個人ブランドを強化し、フィールド外での収入を最大化するスポンサーシップや商業提携を獲得します。',
      
      'service.coaching.title': 'コーチング',
      'service.coaching.short': '個人的・精神的な発展',
      'service.coaching.desc': '個人的・専門的な発展のためのパーソナライズされたガイダンスを提供し、選手が目標を設定し達成し、障害を克服し、フィールド内外でのパフォーマンスを最適化するのを助けます。',
      
      'service.legal.title': '法的アドバイザリー',
      'service.legal.short': '専門的な法的保護',
      'service.legal.desc': 'スポーツ法に特化した法律専門家のチームを持ち、選手のすべての交渉、契約、キャリアに関連する法的事項において彼らの利益を保護することを確保します。',
      
      'service.international.title': '国際的なつながり',
      'service.international.short': 'サッカー選手のためのグローバルな機会',
      'service.international.desc': 'ラテンアメリカのサッカー選手とアジア、ヨーロッパ、北米のリーグとの架け橋を作ることに特化しています。海外での成功を最大化するために、トライアル、移籍、文化的適応を促進します。',
    }
  };
  
  export default translations;